export class DictTypeDto {
    keyId: string = '';
    id: string = '';
    code: string = '';
    name: string = '';
    sequence: number = 0;
    remarks: string = '';
}
